import { ChangeDetectorRef, Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from '@angular/router';
import { ExcelExportEvent, GridComponent, GridDataResult, MultipleSortSettings, RowClassArgs } from "@progress/kendo-angular-grid";
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { BaseGridEditFormLinesComponent } from "@app/cp/shared/base-components/base-grid-edit-formlines.component";
import { CRUDActions } from '@app/cp/shared/enums/CRUDActions';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { Assign, cycleCountDataReference, CycleCountdetails, CycleCountInventory, CycleCountInventoryInput } from '@app/cp/shared/models/CycleCount';
import { InventoryReference } from '@app/cp/shared/models/InventoryReference';
import { SystemEventSubscriptionsBus } from "@app/cp/shared/models/SystemEventSubscriptionsBus";
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { InventoryService } from '@app/cp/shared/services/inventory.service';
import { SystemService } from "@app/cp/shared/services/system.service";
import { CommonValues } from '@app/cp/shared/static/CommonValues';
import { Observable, Subscription } from 'rxjs';
import { MSCLFilterClass } from "@app/cp/shared/classes/filters/MSCLFilterClass";
import { CommonFunctions } from "@app/cp/shared/static/common-functions";
import { aggregateBy, CompositeFilterDescriptor, filterBy, FilterDescriptor, orderBy, SortDescriptor } from "@progress/kendo-data-query";
import {
    AggregateResult,
    AggregateDescriptor,
} from "@progress/kendo-data-query";
import { DateFunctions } from "@app/cp/shared/static/date-functions";
import { GItem } from '../../shared/models/GItem';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { Workbook } from "@progress/kendo-angular-excel-export";
import { saveAs } from "@progress/kendo-file-saver";
import { PersonSel } from '../../shared/models/PersonSelBus';
import * as _ from 'lodash';
import { UseFeatureFlagSet, IFeatureFlagSet } from '@app/cp/shared/decorators/featureflags/featureflagset-decorator';

@UseFeatureFlagSet()
@Component( {
    selector: 'cp-cycle-counting',
    templateUrl: './cycle-counting.component.html',
    styleUrls: [ './cycle-counting.component.scss' ]
} )
export class CycleCountingComponent extends BaseGridEditFormLinesComponent<SystemEventSubscriptionsBus, null, SystemService> implements OnInit {
    compFeatureFlagSet: IFeatureFlagSet = this as any;
    url: string[];
    statusCF: MSCLFilterClass;
    cycleCountClassNameCF: MSCLFilterClass;
    partCycleClassNameCF: MSCLFilterClass;
    warehouseCF: MSCLFilterClass;
    public static virtualizationSettings = { itemHeight: 30, pageSize: 100 };
    public showCountDetail: boolean = false;
    public showCountGrid: boolean = false;
    formActive = false;
    formEditCountActive = false;
    formAddCountVarianceNoteActive = false;
    subs_dataRef: Subscription;
    //referenceData: DQOIReferenceData;
    inventoryReferenceData: InventoryReference = new InventoryReference();
    subs_data_ref: Subscription;
    cycleCountDataReference: cycleCountDataReference;
    personsActive: PersonSel[];
    loading: boolean = false;
    cycleCountData: CycleCountdetails[];
    cycleCountOriginalData: CycleCountdetails[];
    cycleCountAllData: CycleCountdetails[];
    selectedcycleCount: CycleCountdetails;
    cycleCountDetailData: CycleCountInventory[] = [];
    searchText: string = '';
  //  branchCode = "";
    isEdit: boolean;
    cycleCountsId: string = CommonValues.Guid_Empty;
    cycleCountStatus: string = '';
    selectedInventory: CycleCountInventory;
    windowTitle: string = 'Start New Count';
    public aggregates: AggregateDescriptor[] = [
        { field: "costDiff", aggregate: "sum" },
    ];
    costDifTotal: number;
    excelfileName: string;
    @ViewChild( 'detailGrid' ) protected grid: GridComponent;

    public sort: SortDescriptor[] = [ { field: "status", dir: "asc", } ];
    public sortSettings: MultipleSortSettings = {
        mode: "multiple",
        initialDirection: "desc",
        allowUnsort: true,
        showIndexes: true,
    };
    GridFilter: CompositeFilterDescriptor = { filters: [], logic: "and" };
    userFilter: FilterDescriptor = { field: "insertUserId", operator: "eq", value: this.globals.userId };
    onlyActiveFilter: FilterDescriptor = { field: "status", operator: "eq", value: 'Active' };
    branchFilter: FilterDescriptor = { field: "branchCode", operator: "eq", value: this.svc_dataInvRef.cycleCountBranchCode };
    qry_rd: DQOIReferenceDataQuery;
    constructor( globals: GlobalsService,
                 renderer: Renderer2,
                 svc_data: SystemService,
                 cd: ChangeDetectorRef,
                 private _qry_rd: DQOIReferenceDataQuery,
                 public svc_dataInvRef: InventoryService,

                 private _router: Router,
        private _route: ActivatedRoute, featureFlagService: FeatureFlagService, qry_rd: DQOIReferenceDataQuery ) {
        super(globals, renderer, cd, featureFlagService);
        this.qry_rd = qry_rd;
        this.svc_data = svc_data;
        this.url = this._router.url.split( "=");
        this._router.routeReuseStrategy.shouldReuseRoute = function () {
            return false;
        };
        this._router.onSameUrlNavigation = 'reload';
    }

    /**
     * creating the form for new cycle count
     * @private
     */
    createForm( dataItems?: CycleCountdetails ) {
        if ( dataItems ) {
            const assignedValues: string[] = dataItems.assign.map( item => item.id );
            this.editForm = new FormGroup( {
                'warehouse': new FormControl( dataItems.inventoryLocationId, Validators.required ),
                'cycleClass': new FormControl( dataItems.cycleCountClassId, Validators.required ),
                'subcatagory': new FormControl( dataItems.inventorySubCategoryId ),
                'assigned': new FormControl(assignedValues, Validators.required),
                'statusChangeDate': new FormControl(dataItems.statusChangeDate),
                'createDate': new FormControl(dataItems.createDate),
            } );
        } else {
            this.editForm = new FormGroup( {
                'warehouse': new FormControl( "", Validators.required ),
                'cycleClass': new FormControl( "", Validators.required ),
                'subcatagory': new FormControl(),
                'assigned': new FormControl( '', Validators.required ),
                'statusChangeDate': new FormControl(),
                'createDate': new FormControl()
            } );
        }
    }

    override ngOnInit() {
        super.ngOnInit();
        this.getCycleCountingData('0', true);
        this.getCycleCountDataReference();
    }

    public shouldShowDetail = (dataItem: any): boolean => {
        return dataItem && dataItem.editable;
    };

    /**
     * necycle count button click
     * @public
     */
    public newOrEditCycleCount( dataItems?: CycleCountdetails ) {
        if ( dataItems ) {
            this.isEdit = true;
            this.windowTitle = 'Edit ' + dataItems.inventoryLocationName + ' ' + dataItems.cycleCountClassName + ' Count';
            this.cycleCountsId = dataItems.cycleCountsId;
            this.cycleCountStatus = dataItems.status;
            this.createForm( dataItems );
        } else {
            this.isEdit = false;
            this.windowTitle = 'Start New Count';
            this.cycleCountsId = CommonValues.Guid_Empty;
            this.cycleCountStatus = "Active";
            this.createForm();
        }
        this.alreadyCreated = false;
        this.formActive = true;
    }

    /**
     * cancel input click
     * @private
     */
    cancelInput() {
        if ( this.formActive ) {
            this.formActive = false;
            this.editForm = null;
        } else if ( this.formEditCountActive ) {
            this.formEditCountActive = false;
        } else if (this.formAddCountVarianceNoteActive) {
            this.formAddCountVarianceNoteActive = false;
        }

        this.loading = false;
    }

    save() {
        this.saveCycleCount();
    }

    /**
     * Save cycle count
     * @return {BaseMessageInfo}
     * @private
     */
    saveCycleCount(): void {
        this.formActive = false;
        this.loading = true;
        let assignedPerson: Assign[] = [];
        if ( this.editForm.value.assigned.length > 0 ) {
            this.editForm.value.assigned.forEach( assignElements => {
                let assignDetails = { id: assignElements, name: '' };
                assignedPerson.push( assignDetails )
            } );
        } else {
            assignedPerson = [];
        }
        var model: CycleCountdetails = {
            cycleCountsId: this.cycleCountsId,
            inventoryLocationId: this.editForm.value.warehouse,
            cycleCountClassId: this.editForm.value.cycleClass,
            inventorySubCategoryId: this.editForm.value.subcatagory == null ? CommonValues.Guid_Empty : this.editForm.value.subcatagory,
            assign: assignedPerson,
            status: this.cycleCountStatus,
            uniqueCount: 0,
            statusChangeDate: this.editForm.value.statusChangeDate,
            createDate: this.editForm.value.createDate
        }
        this.svc_dataInvRef.saveCycleCount( model ).subscribe( ( data: BaseMessageInfo ) => {
                if ( data.message.trim() == 'Success' ) {
                    this.getCycleCountingData( this.searchText, false );
                    this.notify( this.appCode + " Saved Successfully!" );
                    this.editForm = null;
                }
            },
            ( error ) => {
                this.loading = false;
                console.error( error );
            } );
    }

    goToCount( event ) {
        this.showCountDetail = false;
        if ( event.columnIndex < 6 ) {
            this.loading = true;
            this.rowClick( event.dataItem );
            this.selectedcycleCount = event.dataItem;
            this._router.navigate( [], {
                relativeTo: this._route,
                queryParams: {
                    countId: this.selectedcycleCount.cycleCountsId
                },
                queryParamsHandling: 'merge',
                // preserve the existing query params in the route
                skipLocationChange: false
                // do not trigger navigation
            } );
        }
    }

    navigateBack() {
        this._router.navigate( [], {
            relativeTo: this._route,
            queryParams: {
                countId: null
            },
            queryParamsHandling: 'merge',
            // preserve the existing query params in the route
            skipLocationChange: false
            // do not trigger navigation
        } );
        this.showCountDetail = false;
        this.showCountGrid = true;
    }

    /**
     * get saved cycle count data
     * @param {string} searchText : search text
     * @param {boolean} isFirstload : is first load
     * @return {CycleCountdetails[]}
     * @private
     */
    getCycleCountingData( searchText: string, isFirstload: boolean ): void {
        this.loading = true;
        if ( isFirstload ) {
            this.cycleCountData = [];
        }
        let activeOnly: number = 0; //Mobile is Active Only - which is default

        this.svc_dataInvRef.getCycleCountingData( "0", 0 ).subscribe( ( data ) => {
                if ( data.length > 0 ) {
                    //this.cycleCountData = data;
                    //this.showCountGrid = true;
                    this.cycleCountAllData = _.cloneDeep(data);
                    if (this.searchText.length > 2) {
                        data = data.filter(a => a.inventoryLocationName.toLowerCase().includes(searchText.toLowerCase())
                            || a.cycleCountClassName.toLowerCase().includes(searchText.toLowerCase())
                            || a.insertUserName.toLowerCase().includes(searchText.toLowerCase())
                        );
                    }
                    this.cycleCountOriginalData = data;
                    this.cycleCountData = orderBy( data, this.sort );
                    this.processGridData();
                }
                if ( data.length > 0 && this.url.length != 2 ) {
                    this.showCountGrid = true;
                    this.loading = false;
                }
                if ( data.length > 0 && this.url.length == 2 ) {
                    this.showCountGrid = false;
                    this.showCountDetail = true;
                    this.setInventoryFromRoute( this.url[1] );
                }
            },
            ( error ) => {
                console.error( error );
                this.loading = false;
            } );
    }
    /**
      * get saved cycle count data
      * @param {string} searchText : search text
      * @param {boolean} isFirstload : is first load
      * @return {CycleCountdetails[]}
      * @private
      */
    getCycleCountingWithoutLoading(searchText: string): void {
        this.loading = true;
        var data1 = _.cloneDeep(this.cycleCountAllData);
        var data = [];
        if (this.searchText.length > 2) {
            data = data1.filter(a => a.inventoryLocationName.toLowerCase().includes(searchText.toLowerCase())
                || a.cycleCountClassName.toLowerCase().includes(searchText.toLowerCase())
                || a.insertUserName.toLowerCase().includes(searchText.toLowerCase())
                || a.assignedPersons.join(', ').toLowerCase().includes(searchText.toLowerCase())

            );
            }
        else { data = data1; }
        let activeOnly: number = 0; //Mobile is Active Only - which is default
            if (data.length > 0) {
                //this.cycleCountData = data;
                //this.showCountGrid = true;
                this.cycleCountOriginalData = data;
                this.cycleCountData = orderBy(data, this.sort);
                this.processGridData();
                this.showCountGrid = true;
                this.loading = false;
                //this.loading = false;
            }
             else {
                this.cycleCountData = [];
                this.loading = false;
            }
        /*if (hasRoute){
            setInventoryFromRoute(this.url)
        }*/
    }

    /**
     * get dropdowndata for save new cycle count
     * @return {cycleCountDataReference}
     * @private
     */
    getCycleCountDataReference(): void {
        this.svc_dataInvRef.getCycleCountDataReference().subscribe( ( dataItems: cycleCountDataReference ) => {
                this.cycleCountDataReference = dataItems;
            },
            ( error ) => {
                console.error( error );
            } );
    }

    cycleCountDelete( dataItems: any ): void {
        super.deleteDialog( dataItems );
    }

    cycleCountCancel( cycleCountId?: string ): void {
        if ( this.selectedcycleCount || cycleCountId ) {
            var data = cycleCountId == undefined ? this.selectedcycleCount.cycleCountsId : cycleCountId
            this.callCOnfirmationBox( data, 4 );
        }
    }

    /**
     * delete added cycle count details
     * @param {string} id : selected cycle count id
     * @return {BaseMessageInfo}
     * @private
     */
    deleteCycleCount( id: string ): void {
        this.svc_dataInvRef.cycleCountDelete( id ).subscribe( ( dataItems ) => {
                this.getCycleCountingData( '0', false );
                this.notify( this.appCode + " deleted Successfully!" );
            },
            ( error ) => {
                console.error( error );
            } );
    }

    /**
     * cancel saved cycle count
     * @param {string} id : selected cycle count id
     * @return {BaseMessageInfo}
     * @private
     */
    cancelCycleCount( id: string ): void {
        this.svc_dataInvRef.cancelCount( id ).subscribe( ( dataItems ) => {
                this.getCycleCountingData( '0', false );
                this.notify( this.appCode + " cancelled Successfully!" );
            },
            ( error ) => {
                console.error( error );
            } );
    }
    public commitLoading = false;
    cycleCountCommit(): void {
        this.commitLoading = true;
        if ( this.selectedcycleCount ) {
            var data = this.selectedcycleCount.cycleCountsId;
            this.callCOnfirmationBox( data, 5 );
        }
    }

    /**
     * commit saved cycle count
     * @param {string} id : selected cycle count id
     * @return {BaseMessageInfo}
     * @private
     */
    commitCycleCount( id: string ): void {
        this.loading = true;
        this.commitLoading = true;

        this.svc_dataInvRef.cycleCountCommit( id ).subscribe( ( dataItems ) => {
            this.getCycleCountingData( '0', false );
            this.notify( this.appCode + " Committed  Successfully!" );
            this.commitLoading = false;
            this.loading = false;
        },
        ( error ) => {
            console.error( error );
            this.notify( this.appCode + " Cycle Count failed to commit. " + error, "E", true );
            this.commitLoading = false;
            this.loading = false;
        } );
    }

    rowClick( dataItem: CycleCountdetails ): void {
        var model: CycleCountInventoryInput = {
            InventoryLocationId: dataItem.inventoryLocationId,
            CycleCountClassId: dataItem.cycleCountClassId,
            CycleCountsId: dataItem.cycleCountsId,
            InventorySubCategoryId: dataItem.inventorySubCategoryId,
            ShowInactiveRetired: this.compFeatureFlagSet.featureFlagSet["cycle-count-show-inactive-and-retired"]
        }
        this.getCycleCountInventories( model );
    }

    rowCallback(context: RowClassArgs) {
        if (context.dataItem){
            return {
                readonly: !context.dataItem.editable
            };
        }
        return {};
    }

    /**
     * get inventory parts list from saved cycle count
     * @param {CycleCountInventoryInput} model : selected cycle count inventoryLocationId,inventoryLocationId,inventorySubCategoryId
     * @return {CycleCountInventory}
     * @private
     */
    getCycleCountInventories( model: CycleCountInventoryInput ): void {
        this.cycleCountDetailData = [];
        this.loading = true;
        this.svc_dataInvRef.getCycleCountInventories( model ).subscribe( ( data: CycleCountInventory[] ) => {
            if (data.length > 0) {
                let arr: CycleCountInventory[] = [];
                if (CommonFunctions.hasArrayValue(data)) {
                    for (let i = 0; i < data.length; i++) {
                        var newObject = new CycleCountInventory(data[i])

                        arr.push(newObject);
                    }
                }
                this.cycleCountDetailData = arr;
                this.showCountGrid = false;
                this.showCountDetail = true;
                this.processGridData();
                let total: AggregateResult = aggregateBy( this.cycleCountDetailData, this.aggregates );
                this.costDifTotal = total["costDiff"].sum;
                this.excelfileName = 'CycleCount_' + this.selectedcycleCount.inventoryLocationName + '_' + this.selectedcycleCount.cycleCountClassName + '_' + (DateFunctions.formatDate_short( DateFunctions.getDateOnly( new Date( Date.now() ) ) ));
            } else {
                this.notify( "No parts for this cycle Counting", "W" );
            }
            //this.cycleCountDetailData = data;
            //this.showCountGrid = false;
            //this.showCountDetail = true;
            //this.processGridData();
            this.loading = false;
            },
            ( error ) => {
                this.loading = false;
                console.error( error );
            } );
    }

    refreshCountInventories() {
        this.rowClick( this.selectedcycleCount );
    }
    alreadyCreated = false;
    isCycleCountActiveForWarehouseClass(warehouse, cycleClass): boolean {
        if (!this.compFeatureFlagSet.featureFlagSet['cycle-count-prevent-duplicate-counts'])
        {
            return false;
        }

        if (warehouse && cycleClass) {
            var item = this.cycleCountAllData.find(a => a.cycleCountClassId == cycleClass && a.inventoryLocationId == warehouse && a.status=='Active')
            if (item) return true
            var item = this.cycleCountAllData.find(a => a.cycleCountClassId == '00000000-0000-0000-0000-000000000000' && a.inventoryLocationId == warehouse && a.status == 'Active')
            if (item) return true
            if (cycleClass == '00000000-0000-0000-0000-000000000000') {
                var item = this.cycleCountAllData.find(a => a.inventoryLocationId == warehouse && a.status == 'Active')
                if (item) return true
            }
        }
        return false;
    }
    warehouseValueChange(warehouseValue): void {
        this.alreadyCreated = this.isCycleCountActiveForWarehouseClass(warehouseValue, this.editForm.value.cycleClass)
    }
    cycleClassValueChange(cycleClassValue): void {
        this.alreadyCreated = this.isCycleCountActiveForWarehouseClass(this.editForm.value.warehouse, cycleClassValue)
    }

    searchValueChange( searchValue ): void {
       this.getCycleCountingWithoutLoading(this.searchText) ;
    }
    confirMethod( dataItems ) {
        if ( dataItems.dialogResult == 1 ) {
            if ( dataItems.action == CRUDActions.Delete ) {
                this.deleteCycleCount( dataItems.data.cycleCountsId )
            } else if ( dataItems.action == CRUDActions.Cancel ) {
                this.cancelCycleCount( dataItems.data );
            } else if ( dataItems.action == CRUDActions.Commit ) {
                this.commitCycleCount( dataItems.data );
            }
        }
    }

    callCOnfirmationBox( dataitems, type: number ) {
        if ( type == CRUDActions.Cancel ) {
            this.cnfShow( CommonValues.Message_AreYouSureYouWantToCancelThis, CRUDActions.Cancel, dataitems );
        } else if ( type == CRUDActions.Commit ) {
            this.cnfShow( CommonValues.Message_AreYouSureYouWantToCommitThis, CRUDActions.Commit, dataitems );
        }

    }

    editInventoryCount( dataItem: CycleCountInventory ) {
        this.formEditCountActive = true;
        this.selectedInventory = dataItem;
        this.clearUpdateCount();
    }
    get canAddVarianceNote(): boolean {
        if (!this.selectedInventory || !this.selectedInventory.varianceNote) {
            return false;
        }
        return this.selectedInventory.varianceNote.trim().length > 0;
    }
    addVarianceNote(dataItem: CycleCountInventory) {
        this.formAddCountVarianceNoteActive = true;
        this.selectedInventory = new CycleCountInventory(dataItem);
    }

    saveVarianceNote(): void {
        this.loading = true;
        this.svc_dataInvRef.saveCycleCountVarianceNote(
            this.selectedInventory.inventoryId,
            this.selectedInventory.cycleCountsId,
            this.selectedInventory.varianceNote
        ).subscribe({
            next: (data) => {
                if (!data.saveError) {
                    this.loading = false;
                    this.formAddCountVarianceNoteActive = false;
                    this.selectedInventory = null;
                    this.notify(this.appCode + " Note Saved Successfully!");
                    this.refreshCountInventories();
                }
            },
            error: (error) => {
                this.loading = false;
                console.error(error);
                this.notify("Error saving note", "E", true);
            }
        });
    }
    adjReasonsCBOChanged(e: GItem) {
        this.requiresReasonNote = e.category != CommonValues.Guid_Empty;
    }
    clearUpdateCount() {
        this.requiresReasonNote = false;
        this.selectedInventory.adjustedReason = "";
        this.selectedInventory.cycleCountAdjustedReasonId = CommonValues.Guid_Empty;
    }
    get canSaveAdjustedQty(): boolean {
        var canSave = false;
        if (this.selectedInventory && this.selectedInventory.qtyInput != 0 && CommonFunctions.hasGuidValue(this.selectedInventory.cycleCountAdjustedReasonId) ) {
            if (this.requiresReasonNote) {
                canSave = CommonFunctions.getStringValueIfNull(this.selectedInventory.adjustedReason).trim().length > 0;
            }
            else {
                canSave = true;
            }
        }
        return canSave;
    }
    requiresReasonNote: boolean = false;
//        return this.selectedInventory && this.selectedInventory == CommonValues.Guid_Empty
        //(selectionChange)="adjReasonsCBOChanged($event)"
    updateCount(): void {
        this.formEditCountActive = false;
        this.selectedInventory.inputFrom = 1;
        this.svc_dataInvRef.updateInventoryCount( this.selectedInventory ).subscribe( ( data: BaseMessageInfo ) => {
                if ( data.message.trim() == 'Success' ) {
                    this.rowClick( this.selectedcycleCount );
                    this.notify( this.appCode + " Saved Successfully!" );
                }
            },
            ( error ) => {
                this.loading = false;
                console.error( error );
            } );
    }

    processGridData() {
        if ( CommonFunctions.hasArrayElementValue( this.gridData ) ) {
            this.aggregateResults = aggregateBy( this.gridData, this.aggregates );
        }
        this.statusCF = new MSCLFilterClass( 'status', 'status', this.cycleCountData );
        this.cycleCountClassNameCF = new MSCLFilterClass( 'cycleCountClassName', 'cycleCountClassName', this.cycleCountData );
        this.partCycleClassNameCF = new MSCLFilterClass( 'className', 'className', this.cycleCountDetailData );
        this.warehouseCF = new MSCLFilterClass( 'inventoryLocationName', 'inventoryLocationName', this.cycleCountData );

        this.CreateFilter();
    }

    public sortChange( sort: SortDescriptor[] ): void {
        this.sort = sort;
        this.getCycleCountingWithoutLoading( '' );
    }

    statusChange( type: string ) {
        if (type == 'status') {
            this.svc_dataInvRef.cycleCountShowOnlyActive = !this.svc_dataInvRef.cycleCountShowOnlyActive;
        } else if (type == 'name') {
            this.svc_dataInvRef.cycleCountShowOnlyMine = !this.svc_dataInvRef.cycleCountShowOnlyMine;
        }
        else {

            this.svc_dataInvRef.cycleCountBranchCode = type;
        }
        this.CreateFilter();
    }

    CreateFilter() {
        this.cycleCountData = this.cycleCountOriginalData;

        var filters = []
        if (this.svc_dataInvRef.cycleCountShowOnlyActive ) {
            filters.push(this.onlyActiveFilter);
        }
        if (this.svc_dataInvRef.cycleCountShowOnlyMine) {
            filters.push( this.userFilter);
        }
        if (this.svc_dataInvRef.cycleCountBranchCode) {
            this.branchFilter.value = this.svc_dataInvRef.cycleCountBranchCode ;
            filters.push(this.branchFilter);
        }

        this.GridFilter.filters = filters;
        this.cycleCountData = filterBy( this.cycleCountData, this.GridFilter );

        if ( ! this.svc_dataInvRef.cycleCountShowOnlyActive && ! this.svc_dataInvRef.cycleCountShowOnlyMine ) {
            this.cycleCountData = orderBy( this.cycleCountData, this.sort );
        }
    }

    setInventoryFromRoute( id: string ) {
        this.selectedcycleCount = this.cycleCountData[this.getIndexFromCountId( id )];
        this.rowClick( this.selectedcycleCount );
    }

    getIndexFromCountId( id: string ) {
        return this.cycleCountData.findIndex( x => x.cycleCountsId === id );
    }

    canEditCount( insertUserid, status ) {
        return (((this.rights.canEditInventoryCount || this.rights.canCreateInventoryCount) && this.globals.userId === insertUserid) || this.rights.inventoryCountAdmin) && status === 'Active';
    }
    canCancelCount(insertUserid, status) {
        return (((this.rights.canCommitInventoryCount) && this.globals.userId === insertUserid) || this.rights.inventoryCountAdmin || this.rights.canCancelAnyCycleCount) && status === 'Active';
    }
    canCommitCount( insertUserid, status ) {
        return ((this.rights.canCommitInventoryCount && this.globals.userId === insertUserid) || this.rights.inventoryCountAdmin) && status === 'Active';
    }
    public view: Observable<GridDataResult>;
    private allCategories: GridDataResult;
    public exportGridToExcel(): void {
        this.grid.saveAsExcel();
    }
    public onExcelExport(args: ExcelExportEvent): void {
        // Prevent automatically saving the file. We will save it manually after we fetch and add the details
        args.preventDefault();
        this.loading = true;
        const workbook = args.workbook;
        const rows = workbook.sheets[0].rows;
        workbook.sheets[0].title = 'Cycle Count';

        // Get the default header styles.
        // Aternatively set custom styles for the details
        // https://www.telerik.com/kendo-angular-ui/components/excelexport/api/WorkbookSheetRowCell/
        const headerOptions = {
            color: "#ffffff",
            background: "#1b232c",
            fontSize: 16,
            bold: true,
        };
        const cellOptions = {
            color: "#1b232c",
            fontSize: 16,
        };
        const subHeaderOptions = {
            color: "#1b232c",
            background: "#E4E8EF",
            fontSize: 14,
            bold: true,
            colSpan:2,
        };
        const subCellOptions = {
            color: "#4B5363",
            background: "#E4E8EF",
            fontSize: 14,
            colSpan:2,
        };
        const avgCostCol = 5;
        const costDiffCol = 11;
        const lastDateCountedCol = 12;
        //rows.shift();
        rows.splice( 0, 1, {
            cells: [
                Object.assign({}, headerOptions, { value: "Part #" }),
                Object.assign({}, headerOptions, { value: "Description" }),
                Object.assign({}, headerOptions, { value: "Summary" }),
                Object.assign({}, headerOptions, { value: "Non Inventory" }),
                Object.assign({}, headerOptions, { value: "Cycle Class" }),
                Object.assign({}, headerOptions, { value: "Average Price" }),
                Object.assign({}, headerOptions, { value: "Row" }),
                Object.assign({}, headerOptions, { value: "Bay" }),
                Object.assign({}, headerOptions, { value: "Shelf" }),
                Object.assign({}, headerOptions, { value: "Qty Expected" }),
                Object.assign({}, headerOptions, { value: "Qty Counted" }),
                Object.assign({}, headerOptions, { value: "Cost Diff" }),
                Object.assign({}, headerOptions, { value: "Last Date" }),
            ],
        });

        var curRow = 1;
        for (let row = 0; row < this.cycleCountDetailData.length ; row++) {
            let data: CycleCountInventory = this.cycleCountDetailData[row];
            rows.splice(curRow, 1, {
                cells: [
                    Object.assign({}, cellOptions, { value: data.number }),
                    Object.assign({}, cellOptions, { value: data.fullDescription }),
                    Object.assign({}, cellOptions, { value: data.inventoryDesc }),
                    Object.assign({}, cellOptions, { value: data.nonPartText() }),
                    Object.assign({}, cellOptions, { value: data.className }),
                    Object.assign({}, cellOptions, { value: data.avgCost }),
                    Object.assign({}, cellOptions, { value: data.aisle }),
                    Object.assign({}, cellOptions, { value: data.section }),
                    Object.assign({}, cellOptions, { value: data.bin }),
                    Object.assign({}, cellOptions, { value: data.quantity }),
                    Object.assign({}, cellOptions, { value: data.qtyCounted }),
                    Object.assign({}, cellOptions, { value: data.costDiff }),
                    Object.assign( {}, cellOptions, { value: ( data.lastDateCounted == null ? '' : (new Date(data.lastDateCounted)).toLocaleString('en-US')) }),
                ],
            });

            rows[curRow].cells[avgCostCol].format = "$#.00";
            rows[curRow].cells[costDiffCol].format = "$#.00";

            if (rows[curRow].cells[lastDateCountedCol].value == null) {
                rows[curRow].cells[lastDateCountedCol].value = '';
            }

            curRow = curRow + 1

            if (data.history && data.history.length>0 ) {
                rows.splice( curRow, 0, {
                    cells: [
                        Object.assign( {}, subHeaderOptions, { value: "Tech" } ),
                        Object.assign( {}, subHeaderOptions, { value: "Counted" } ),
                        Object.assign( {}, subHeaderOptions, { value: "AdjustedQty" } ),
                        Object.assign( {}, subHeaderOptions, { value: "AdjustedReason" } ),
                        Object.assign( {}, subHeaderOptions, { value: "Date Counted" } ),
                    ],
                })

                curRow = curRow + 1
                for (let row2 = 0; row2 < data.history.length; row2++) {
                    let historyData = data.history[row2];
                    rows.splice(curRow, 0, {
                        cells: [
                            Object.assign( {}, subCellOptions, { value: historyData.tech }),
                            Object.assign( {}, subCellOptions, { value: historyData.counted }),
                            Object.assign( {}, subCellOptions, { value: historyData.adjustedQty }),
                            Object.assign( {}, subCellOptions, { value: historyData.adjustedReason }),
                            Object.assign( {}, subCellOptions, { value: (new Date(historyData.dateCounted)).toLocaleString('en-US') }),
                        ],
                    });
                    curRow = curRow + 1
                }
            }
            else {

            }

        }

        let workbookSuffix: string = '_' + this.selectedcycleCount.inventoryLocationName + '_' + this.selectedcycleCount.cycleCountClassName;

        // create a Workbook and save the generated data URL
        // https://www.telerik.com/kendo-angular-ui/components/excelexport/api/Workbook/
        new Workbook(workbook).toDataURL().then((dataUrl: string) => {
            // https://www.telerik.com/kendo-angular-ui/components/filesaver/
            saveAs(dataUrl, "CycleCount" + workbookSuffix + ".xlsx");
            this.loading = false;
        });

    }
    personItemDisabled(itemArgs: { dataItem: PersonSel, index: any }) {
        return !itemArgs.dataItem.isActive;
    }
    invLocDisabled(itemArgs: { dataItem: GItem, index: any }) {
        return !itemArgs.dataItem.canSelect;
    }

}
